import { AdminUsersScreen } from 'feature/admin/admin-users';
import { stringToFbKey } from 'internal/firebase';
import { CLICK, component, componentWithVariants, demoFile, feature, INPUT, POPUP, POPUP_CLOSE, story, variant } from 'system/demo';

demoFile('feature/admin/admin-users', {});

const collections = {
    fakeAdmin: [
        { key: 'admin@admin%dorg', roles: ['Owner'], email: 'admin@admin.org' },
        { key: 'bob@bob%dcom', roles: ['Moderator'], email: 'bob@bob.com' },
    ],
};

componentWithVariants('AdminUsersScreen', AdminUsersScreen, {}, [
    variant('Lacks capability', {}),
    variant(
        null,
        {
            state: {
                collections,
                roles: ['Owner'],
                serverCall: {
                    admin: {
                        getAdminUsers: ({ datastore }) => datastore.getCollection('fakeAdmin'),
                        setAdminRoles: ({ datastore, email, roles }) =>
                            datastore.updateObject('fakeAdmin', stringToFbKey(email), { roles }),
                        addAdminUsers: ({ datastore, emails, roles }) =>
                            datastore.addObject('fakeAdmin', { roles, email: 'fake@fake.com' }),
                    },
                },
            },
        },
        [
            story('Set roles', [CLICK('Moderator popup'), POPUP(CLICK('Developer')), POPUP_CLOSE()]),
            story('Add user', [
                INPUT('new-emails', 'fake@fake.com'),
                CLICK('Select roles popup'),
                POPUP(CLICK('Developer')),
                POPUP_CLOSE(),
                CLICK('Add Admins'),
            ]),
        ],
    ),
]);

feature('adminusers', {
    structureKey: 'admin',
    state: {
        collections,
        roles: ['Owner'],
        serverCall: {
            admin: {
                getAdminUsers: ({ datastore }) => datastore.getCollection('fakeAdmin'),
            },
        },
    },
});
